import React, { useState, useEffect } from "react";
import { Add } from "@mui/icons-material";
import { PopUpWindow, AddPoolActionForm } from "../../components";
import "./PoolActionButton.css";

const PoolActionButton = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [buttonWidth, setButtonWidth] = useState(
    window.innerWidth <= 768 ? "100%" : "auto"
  );

  const user = JSON.parse(localStorage.getItem("user"));
  const [popUpWindowIsOpen, setPopUpWindowIsOpen] = useState(false);

  const handleClick = () => {
    setPopUpWindowIsOpen(true);
  };

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth <= 768 ? "100%" : "auto";
      setButtonWidth(newWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {true ? (
        <>
          {popUpWindowIsOpen && (
            <PopUpWindow
              onClose={() => {
                setPopUpWindowIsOpen(false);
              }}
              unfocusClose={false}
              maxWidth="sm" // Add this to make the popup wider
            >
              <AddPoolActionForm setShowAddPoolActionForm={setPopUpWindowIsOpen} />
            </PopUpWindow>
          )}
          <div className="pool-action-button">
            <button
              className="pool-action-button__button"
              style={{
                backgroundColor: props.color || "var(--primary-color)",
                color: props.textColor || "var(--primary-text-color)",
                fontSize: props.fontSize || "15px",
                fontWeight: props.fontWeight || "600",
                width: props.width || buttonWidth,
              }}
              onClick={handleClick}
            >
              <Add />
              <span>Create Pool Action</span>
            </button>
          </div>
        </>
      ) : null}
    </>
  );
};

export default PoolActionButton;
